import { jsx as _jsx } from "react/jsx-runtime";
import { PhoneNumberInput, DEFAULT_CZECH_PHONE_NUMBER_PREFIX } from '@bos/ui';
import { useController } from 'react-hook-form';
import { getPhoneNumberErrorMessage } from './getPhoneNumberErrorMessage';
export const PhoneNumberField = ({ control, name, registerOptions, defaultPhonePrefix = DEFAULT_CZECH_PHONE_NUMBER_PREFIX, ...props }) => {
    const controller = useController({ control, name });
    const handleValueChange = (value, prefix) => {
        if (value || prefix) {
            controller.field.onChange({ ...controller.field.value, value, prefix });
        }
    };
    const phoneNumberErrorMessage = getPhoneNumberErrorMessage(controller.fieldState.error);
    const phoneNumberWithoutPrefix = controller.field.value?.value;
    const phonePrefix = controller.field.value?.prefix ?? defaultPhonePrefix;
    return (_jsx(PhoneNumberInput, { ...props, ref: controller.field.ref, name: name, error: phoneNumberErrorMessage, phoneNumberWithoutPrefix: phoneNumberWithoutPrefix, phonePrefix: phonePrefix, onValueChange: handleValueChange }));
};
